import axios from 'axios'

function getInstance() {
  const accessToken = window.localStorage.accessToken
  return axios.create({
    baseURL: `${import.meta.env.VITE_API_URL}/api/v1`,
    headers: accessToken
      ? {
          'x-access-token': accessToken
        }
      : {}
  })
}

export { getInstance }
